export default "__VITE_ASSET__9dccXqGw__";